import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'dark' | 'light';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const {
    days,
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown();
  if (expired) {
    return <p className="text-sm font-semibold uppercase tracking-wide text-gold-300" data-id="element-25" data-mp="3q1dqk2vmn849">La oferta especial finalizó</p>;
  }
  const units = [...(days > 0 ? [{
    value: days,
    label: 'Días'
  }] : []), {
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  const box = tone === 'dark' ? 'bg-cream text-petrol-900' : 'bg-petrol-800 text-cream';
  const label = tone === 'dark' ? 'text-petrol-100' : 'text-petrol-700';
  return <div className="flex items-start gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-26" data-mp="10clayhlz829e">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-27" data-mp="15by7ju2ngnp6" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-28" data-mp="15awker8d0ar3">
            <span className={`flex h-12 w-12 items-center justify-center rounded-lg font-serif text-2xl tabular-nums sm:h-16 sm:w-16 sm:text-4xl ${box}`} data-id="element-29" data-mp="y0n27r4lhdbm">
              {String(u.value).padStart(2, '0')}
            </span>
            <span className={`mt-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${label}`} data-id="element-30" data-mp="17py9r9bu29xe">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className={`pt-2.5 font-serif text-xl sm:pt-4 sm:text-2xl ${tone === 'dark' ? 'text-gold-400' : 'text-terra-500'}`} data-id="element-31" data-mp="f2atu7lic7h3">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}